import { AmaruSnackbar } from '@/types/components/AmaruSnackbar';
import { PicturePreview } from '@/types/components/PicturePreview';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface Components {
  snackbar: AmaruSnackbar;
  picturePreview: PicturePreview;
  confetti: {
    /** Determines whether the component should be displayed */
    show: boolean;
    /**
     * Controls the confetti animation:
     * - When `true`, confetti will keep spawning.
     * - When toggled to `false`, confetti stops spawning but the component remains visible.
     */
    running: boolean;
    /**
     * Specifies the duration (in milliseconds) before automatically setting `running` to `false`.
     */
    duration?: number;
  };
}

const initialState: Components = {
  snackbar: {
    open: false,
    message: null,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    severity: 'info',
  },
  picturePreview: {
    show: false,
    picture: '',
    title: 'Foto',
  },
  confetti: {
    show: false,
    running: false,
    duration: 3000,
  },
};

const { reducer, actions } = createSlice({
  name: 'global_config',
  initialState,
  reducers: {
    setSnackbar(state: Components, action: PayloadAction<AmaruSnackbar>): void {
      state.snackbar = {
        ...action.payload,
        ...(!action.payload.anchorOrigin && {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        }),
        ...(!action.payload.severity && { severity: state.snackbar.severity }),
      };
    },
    setPicturePreview(state: Components, action: PayloadAction<PicturePreview>): void {
      if (!action.payload.show) {
        action.payload.picture = '';
        action.payload.title = 'Foto';
      }
      state.picturePreview = action.payload;
    },
    setConfetti(state: Components, action: PayloadAction<Components['confetti']>) {
      state.confetti = action.payload;
    },
  },
});

export default reducer;

export const { setSnackbar, setPicturePreview, setConfetti } = actions;
